document.addEventListener('alpine:init', () => {
  Alpine.store('search', {
    results: { products: [] },
    query: '',
    fetch(query) {
      this.query = query;
      fetch(
        `/search/suggest.json?q=${query}&resources[type]=product&resources[options][fields]=title,product_type,variants.title,body,tag,vendor&resources[limit]=5`
      )
        .then((response) => response.json())
        .then((data) => {
          this.results.products = data.resources.results.products;
        });
    },
    highlight(text) {
      const queryRegex = new RegExp(`(${this.query})`, 'gi');
      return text.replace(queryRegex, '<strong>$1</strong>');
    },
  });
});
